import { defineComponent as N, resolveComponent as u, createBlock as b, openBlock as i, normalizeClass as p, withCtx as _, createElementBlock as a, createCommentVNode as l, renderSlot as m, resolveDynamicComponent as w, h as O, createElementVNode as d, createVNode as v, toDisplayString as h, createTextVNode as E, normalizeStyle as M, onMounted as R } from "vue";
const I = N({
  name: "AdnButton",
  props: {
    kind: {
      type: String,
      default: "primary",
      validator: (e) => ["primary", "secondary", "link", "tertiary", "light"].includes(e)
    },
    iconName: {
      type: String,
      default: ""
    },
    iconPosition: {
      type: String,
      default: "right",
      validator: (e) => ["right", "left"].includes(e)
    },
    markup: {
      type: String,
      default: "button",
      validator: (e) => ["button", "router-link", "div", "span", "a"].includes(e)
    },
    color: {
      type: String,
      default: "default",
      validator: (e) => ["default", "white"].includes(e)
    },
    route: {
      type: [String, Object],
      default: void 0
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  computed: {
    classNames() {
      return [
        `adn-button--${this.kind.toLowerCase()}`,
        `adn-button--${this.kind.toLowerCase()}-${this.color.toLowerCase()}`
      ];
    },
    iconClassNames() {
      return ["adn-icon", `adn-icon--${this.iconName.toLowerCase()}`];
    },
    iconsPositionIsRight() {
      return this.iconPosition === "right";
    }
  },
  methods: {
    onClick(e) {
      return this.$emit("click", e);
    },
    hasContent() {
      return !!this.$slots.default;
    }
  }
}), f = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, s] of t)
    n[o] = s;
  return n;
}, L = {
  key: 1,
  class: "adn-button__text",
  "data-test-text": ""
}, T = {
  key: 1,
  class: "adn-button__text",
  "data-test-text": ""
};
function A(e, t, n, o, s, C) {
  const r = u("router-link");
  return e.route ? (i(), b(r, {
    key: 0,
    to: e.route,
    class: p(["adn-button", e.classNames]),
    "data-test-button": "",
    disabled: e.disabled ? "disabled" : void 0,
    onClick: e.onClick
  }, {
    default: _(() => [
      e.iconName && !e.iconsPositionIsRight ? (i(), a("span", {
        key: 0,
        class: p([e.iconClassNames, "adn-button__icon adn-button__icon--left"]),
        "data-test-icon": "",
        "aria-hidden": "true"
      }, null, 2)) : l("", !0),
      e.hasContent() ? (i(), a("span", L, [
        m(e.$slots, "default")
      ])) : l("", !0),
      e.iconName && e.iconsPositionIsRight ? (i(), a("span", {
        key: 2,
        class: p([e.iconClassNames, "adn-button__icon adn-button__icon--right"]),
        "data-test-icon": "",
        "aria-hidden": "true"
      }, null, 2)) : l("", !0)
    ]),
    _: 3
  }, 8, ["to", "class", "disabled", "onClick"])) : (i(), b(w(e.markup), {
    key: 1,
    class: p(["adn-button", e.classNames]),
    role: "button",
    "data-test-button": "",
    disabled: e.disabled ? "disabled" : void 0,
    onClick: e.onClick
  }, {
    default: _(() => [
      e.iconName && !e.iconsPositionIsRight ? (i(), a("span", {
        key: 0,
        class: p([e.iconClassNames, "adn-button__icon adn-button__icon--left"]),
        "data-test-icon": "",
        "aria-hidden": "true"
      }, null, 2)) : l("", !0),
      e.hasContent() ? (i(), a("span", T, [
        m(e.$slots, "default")
      ])) : l("", !0),
      e.iconName && e.iconsPositionIsRight ? (i(), a("span", {
        key: 2,
        class: p([e.iconClassNames, "adn-button__icon adn-button__icon--right"]),
        "data-test-icon": "",
        "aria-hidden": "true"
      }, null, 2)) : l("", !0)
    ]),
    _: 3
  }, 8, ["class", "disabled", "onClick"]));
}
const y = /* @__PURE__ */ f(I, [["render", A]]), g = {};
function P(e) {
  return Object.keys(e).reduce((t, n) => (e[n] !== !1 && e[n] !== null && e[n] !== void 0 && (t[n] = e[n]), t), {});
}
const S = {
  name: "InlineSvg",
  inheritAttrs: !1,
  render() {
    return this.svgElSource ? O(
      "svg",
      Object.assign(
        {},
        // source attrs
        this.getSvgAttrs(this.svgElSource),
        // component attrs and listeners
        P(this.$attrs),
        // content
        { innerHTML: this.getSvgContent(this.svgElSource) }
      )
    ) : null;
  },
  props: {
    src: {
      type: String,
      required: !0
    },
    title: {
      type: String
    },
    transformSource: {
      type: Function,
      default: (e) => e
    },
    keepDuringLoading: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["loaded", "unloaded", "error"],
  data() {
    return {
      /** @type {SVGElement} */
      svgElSource: null,
      /** @type {XMLHttpRequest} */
      request: void 0
    };
  },
  watch: {
    src(e) {
      this.getSource(e);
    }
  },
  mounted() {
    this.getSource(this.src);
  },
  methods: {
    getSvgAttrs(e) {
      let t = {};
      const n = e.attributes;
      if (!n)
        return t;
      for (let o = n.length - 1; o >= 0; o--)
        t[n[o].name] = n[o].value;
      return t;
    },
    getSvgContent(e) {
      return e = e.cloneNode(!0), e = this.transformSource(e), this.title && D(e, this.title), e.innerHTML;
    },
    /**
     * Get svgElSource
     * @param {string} src
     */
    getSource(e) {
      g[e] || (g[e] = this.download(e)), this.svgElSource && g[e].getIsPending() && !this.keepDuringLoading && (this.svgElSource = null, this.$emit("unloaded")), g[e].then((t) => {
        this.svgElSource = t, this.$nextTick(() => {
          this.$emit("loaded", this.$el);
        });
      }).catch((t) => {
        this.svgElSource && (this.svgElSource = null, this.$emit("unloaded")), delete g[e], this.$emit("error", t);
      });
    },
    /**
     * Get the contents of the SVG
     * @param {string} url
     * @returns {PromiseWithState<Element>}
     */
    download(e) {
      return Z(new Promise((t, n) => {
        const o = new XMLHttpRequest();
        o.open("GET", e, !0), this.request = o, o.onload = () => {
          if (o.status >= 200 && o.status < 400)
            try {
              let r = new DOMParser().parseFromString(o.responseText, "text/xml").getElementsByTagName("svg")[0];
              r ? t(r) : n(new Error('Loaded file is not valid SVG"'));
            } catch (s) {
              n(s);
            }
          else
            n(new Error("Error loading SVG"));
        }, o.onerror = n, o.send();
      }));
    }
  }
};
function D(e, t) {
  const n = e.getElementsByTagName("title");
  if (n.length)
    n[0].textContent = t;
  else {
    const o = document.createElementNS("http://www.w3.org/2000/svg", "title");
    o.textContent = t, e.insertBefore(o, e.firstChild);
  }
}
function Z(e) {
  if (e.getIsPending) return e;
  let t = !0, n = e.then(
    (o) => (t = !1, o),
    (o) => {
      throw t = !1, o;
    }
  );
  return n.getIsPending = function() {
    return t;
  }, n;
}
const F = {}, H = { class: "p-form-container" }, B = { class: "p-form-container__title" }, V = { class: "p-form-container__body" };
function q(e, t) {
  return i(), a("div", H, [
    d("h1", B, [
      m(e.$slots, "title", {}, void 0, !0)
    ]),
    d("div", V, [
      m(e.$slots, "body", {}, void 0, !0)
    ])
  ]);
}
const U = /* @__PURE__ */ f(F, [["render", q], ["__scopeId", "data-v-2c0dfe81"]]), j = "data:image/svg+xml,%3csvg%20height='250'%20viewBox='0%200%20238%20176'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_1530_12970)'%3e%3cstyle%3e%20.background-shadows%20{%20fill:%20%23CB9757;%20}%20%3c/style%3e%3cpath%20opacity='0.1'%20d='M2.56152%2084.4014C6.31969%2098.8796%2014.2687%20111.395%2026.8306%20117.462C52.9452%20130.07%20111.84%20123.568%20155.796%20116.103C178.533%20112.243%20198.519%20101.588%20213.036%2086.5948L2.56152%2084.4014Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M233.062%2016.2507H208.945C207.8%2016.2507%20206.861%2015.4053%20206.861%2014.3722C206.861%2013.3391%20207.8%2012.4915%20208.945%2012.4915H213.116C211.97%2012.4915%20211.033%2011.6461%20211.033%2010.6108C211.033%209.57561%20211.97%208.73232%20213.116%208.73232H210.139C208.992%208.73232%20208.053%207.88688%20208.053%206.85165C208.053%205.81641%20208.992%204.97313%20210.139%204.97313H222.727C219.934%203.80202%20216.669%202.96952%20212.906%202.5317C178.581%20-1.44317%20166.326%201.18589%20162.004%203.88829C156.615%207.29862%20150.63%209.66497%20144.362%2010.8632C123.184%2014.8035%2083.5796%2019.5441%2047.6834%209.35347C29.8423%204.27866%2016.5817%2012.8431%208.63477%2027.1595H237.251C236.953%2022.9992%20236.059%2019.1558%20234.419%2015.7935C234.031%2016.0924%20233.553%2016.2534%20233.062%2016.2507Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M0.517077%2054.1812C-0.409276%2062.6014%20-0.0943817%2071.1115%201.45175%2079.4409L213.199%2086.4266C219.027%2080.4004%20223.98%2073.5892%20227.911%2066.192L0.517077%2054.1812ZM84.2656%2072.2007H80.0963C81.243%2072.2007%2082.182%2073.0483%2082.182%2074.0814C82.182%2075.1145%2081.243%2075.9599%2080.0963%2075.9599H55.9787C54.8342%2075.9599%2053.8952%2075.1145%2053.8952%2074.0814C53.8952%2073.0483%2054.8342%2072.2007%2055.9787%2072.2007H60.1501C59.0034%2072.2007%2058.0666%2071.3553%2058.0666%2070.3222C58.0666%2069.2891%2059.0034%2068.4415%2060.1501%2068.4415H57.1709C56.0242%2068.4415%2055.0852%2067.5961%2055.0852%2066.563C55.0852%2065.5299%2056.0242%2064.6823%2057.1709%2064.6823H81.2885C82.4352%2064.6823%2083.372%2065.5278%2083.372%2066.563C83.372%2067.5982%2082.4352%2068.4415%2081.2885%2068.4415H84.2656C85.4123%2068.4415%2086.3491%2069.287%2086.3491%2070.3222C86.3491%2071.3574%2085.4123%2072.2007%2084.2656%2072.2007Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M237.26%2027.2888L6.08401%2032.3572C3.27133%2038.877%201.40631%2046.2487%200.547363%2053.8879H233.21C234.724%2049.4185%20235.847%2044.827%20236.568%2040.1646C237.262%2035.6764%20237.539%2031.3349%20237.26%2027.2888ZM47.4844%2043.9065H43.3152C44.4619%2043.9065%2045.4009%2044.7541%2045.4009%2045.7872C45.4009%2046.8203%2044.4619%2047.6678%2043.3152%2047.6678H19.1976C18.053%2047.6678%2017.114%2046.8203%2017.114%2045.7872C17.114%2044.7541%2018.053%2043.9065%2019.1976%2043.9065H23.369C22.2223%2043.9065%2021.2854%2043.0611%2021.2854%2042.028C21.2854%2040.9949%2022.2223%2040.1473%2023.369%2040.1473H20.3897C19.243%2040.1473%2018.304%2039.3019%2018.304%2038.2688C18.304%2037.2357%2019.243%2036.3881%2020.3897%2036.3881H44.5073C45.654%2036.3881%2046.5909%2037.2335%2046.5909%2038.2688C46.5909%2039.304%2045.654%2040.1473%2044.5073%2040.1473H47.4844C48.6311%2040.1473%2049.568%2040.9949%2049.568%2042.028C49.568%2043.0611%2048.6311%2043.9065%2047.4844%2043.9065Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M117.934%20168.959C171.344%20168.959%20214.642%20164.988%20214.642%20160.09C214.642%20155.192%20171.344%20151.222%20117.934%20151.222C64.523%20151.222%2021.2251%20155.192%2021.2251%20160.09C21.2251%20164.988%2064.523%20168.959%20117.934%20168.959Z'%20class='background-shadows'/%3e%3cpath%20d='M112.288%20165.122C149.152%20165.122%20179.035%20135.333%20179.035%2098.5864C179.035%2061.8399%20149.152%2032.051%20112.288%2032.051C75.4251%2032.051%2045.5415%2061.8399%2045.5415%2098.5864C45.5415%20135.333%2075.4251%20165.122%20112.288%20165.122Z'%20class='background-shadows'/%3e%3cpath%20d='M147.311%20132.022C147.311%20142.526%20130.746%20132.92%20112.988%20132.92C95.2288%20132.92%2077.2666%20142.129%2077.2666%20131.626C77.2666%20125.636%2082.9915%20117.307%2091.2045%20111.257C97.3924%20106.698%20104.991%20103.433%20112.624%20103.433C120.474%20103.433%20128.163%20106.968%20134.297%20111.82C142.038%20117.939%20147.311%20126.16%20147.311%20132.022Z'%20fill='%23233C52'/%3e%3cpath%20d='M134.294%20111.816C124.855%20110.399%20107.782%20108.671%2091.2041%20111.253C97.392%20106.694%20104.991%20103.428%20112.624%20103.428C120.471%20103.428%20128.16%20106.963%20134.294%20111.816Z'%20fill='%23F6F5F3'/%3e%3cpath%20opacity='0.05'%20d='M77.2666%2051.6191C77.2666%2051.6191%2057.1603%2064.4323%2057.3247%2084.4749C57.4892%20104.517%2077.2666%2051.6191%2077.2666%2051.6191Z'%20fill='%2314222E'/%3e%3cpath%20d='M179.009%2015.431C179.009%2015.431%20160.792%2014.3375%20162.94%2027.0623C162.94%2027.0623%20162.508%2029.3096%20164.559%2030.3319C164.559%2030.3319%20164.591%2029.3894%20166.426%2029.7086C167.08%2029.8177%20167.744%2029.8495%20168.406%2029.8035C169.299%2029.7429%20170.149%2029.3931%20170.824%2028.8071C170.824%2028.8071%20175.946%2026.7%20177.938%2018.3555C177.938%2018.3555%20179.412%2016.5352%20179.353%2016.0694L176.279%2017.3764C176.279%2017.3764%20177.328%2019.587%20176.495%2021.4246C176.495%2021.4246%20176.396%2017.4583%20175.805%2017.5424C175.686%2017.5618%20174.208%2018.3081%20174.208%2018.3081C174.208%2018.3081%20176.015%2022.16%20174.641%2024.9573C174.641%2024.9573%20175.158%2020.2125%20173.633%2018.5863L171.469%2019.8458C171.469%2019.8458%20173.581%2023.8229%20172.149%2027.0688C172.149%2027.0688%20172.516%2022.091%20171.015%2020.1521L169.052%2021.6769C169.052%2021.6769%20171.036%2025.5979%20169.827%2028.2895C169.827%2028.2895%20169.669%2022.4943%20168.628%2022.0565C168.628%2022.0565%20166.913%2023.5662%20166.651%2024.1852C166.651%2024.1852%20168.01%2027.0299%20167.168%2028.531C167.168%2028.531%20166.651%2024.6705%20166.227%2024.6489C166.227%2024.6489%20164.518%2027.2068%20164.338%2028.9624C164.338%2028.9624%20164.414%2026.3527%20165.811%2024.4052C165.811%2024.4052%20164.158%2024.6877%20163.196%2025.7575C163.196%2025.7575%20163.462%2023.948%20166.225%2023.7905C166.225%2023.7905%20167.637%2021.8494%20168.016%2021.733C168.016%2021.733%20165.257%2021.5022%20163.585%2022.242C163.585%2022.242%20165.056%2020.536%20168.52%2021.3103L170.467%2019.7358C170.467%2019.7358%20166.837%2019.2398%20165.296%2019.7876C165.296%2019.7876%20167.068%2018.2779%20170.989%2019.3778L173.098%2018.1204C173.098%2018.1204%20170.002%2017.4562%20168.157%2017.6891C168.157%2017.6891%20170.104%2016.6431%20173.715%2017.7775L175.23%2017.1025C175.23%2017.1025%20172.96%2016.6582%20172.296%2016.5892C171.631%2016.5201%20171.597%2016.3347%20171.597%2016.3347C173.038%2016.1011%20174.516%2016.2721%20175.866%2016.8286C175.866%2016.8286%20179.063%2015.6316%20179.009%2015.431Z'%20class='background-shadows'/%3e%3cpath%20d='M160.325%209.77393C160.325%209.77393%20152.103%209.27788%20153.064%2015.0277C153.064%2015.0277%20152.871%2016.0436%20153.795%2016.5051C153.795%2016.5051%20153.808%2016.0738%20154.639%2016.2247C154.934%2016.2732%20155.234%2016.2876%20155.533%2016.2679C155.937%2016.2391%20156.321%2016.081%20156.627%2015.8171C156.627%2015.8171%20158.94%2014.8638%20159.84%2011.0939C159.84%2011.0939%20160.507%2010.2721%20160.489%2010.0608L159.1%2010.6517C159.1%2010.6517%20159.576%2011.6503%20159.202%2012.4806C159.202%2012.4806%20159.157%2010.6884%20158.89%2010.7315C158.836%2010.7315%20158.168%2011.0766%20158.168%2011.0766C158.168%2011.0766%20158.986%2012.8171%20158.369%2014.0809C158.369%2014.0809%20158.603%2011.9371%20157.915%2011.2017L156.937%2011.7711C156.937%2011.7711%20157.891%2013.5698%20157.244%2015.0364C157.244%2015.0364%20157.408%2012.7869%20156.731%2011.9113L155.844%2012.5993C155.844%2012.5993%20156.74%2014.3699%20156.195%2015.5863C156.195%2015.5863%20156.123%2012.9681%20155.652%2012.7696C155.652%2012.7696%20154.877%2013.4512%20154.758%2013.7315C154.758%2013.7315%20155.372%2015.0256%20154.992%2015.6963C154.992%2015.6963%20154.758%2013.9515%20154.559%2013.9451C154.559%2013.9451%20153.787%2015.0989%20153.706%2015.8861C153.744%2015.1535%20153.973%2014.4434%20154.371%2013.8264C153.926%2013.9104%20153.515%2014.1226%20153.189%2014.4368C153.189%2014.4368%20153.308%2013.6194%20154.561%2013.5482C154.561%2013.5482%20155.199%2012.6726%20155.37%2012.6187C155.37%2012.6187%20154.124%2012.5151%20153.369%2012.8494C153.369%2012.8494%20154.033%2012.0773%20155.6%2012.4181L156.465%2011.7085C156.465%2011.7085%20154.825%2011.4928%20154.128%2011.7301C154.128%2011.7301%20154.929%2011.0486%20156.701%2011.5468L157.653%2010.9774C157.653%2010.9774%20156.255%2010.6776%20155.42%2010.7854C155.42%2010.7854%20156.301%2010.3131%20157.932%2010.8264L158.614%2010.5202C158.614%2010.5202%20157.588%2010.3196%20157.289%2010.2894C156.991%2010.2592%20156.971%2010.1751%20156.971%2010.1751C157.621%2010.0674%20158.288%2010.1421%20158.897%2010.3908C158.897%2010.3908%20160.349%209.86451%20160.325%209.77393Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M232.173%20157.944C235.391%20157.944%20238%20157.505%20238%20156.963C238%20156.421%20235.391%20155.981%20232.173%20155.981C228.955%20155.981%20226.347%20156.421%20226.347%20156.963C226.347%20157.505%20228.955%20157.944%20232.173%20157.944Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M10.119%20174.269C13.337%20174.269%2015.9456%20173.829%2015.9456%20173.287C15.9456%20172.745%2013.337%20172.306%2010.119%20172.306C6.90112%20172.306%204.29248%20172.745%204.29248%20173.287C4.29248%20173.829%206.90112%20174.269%2010.119%20174.269Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M43.9428%20175.5C47.1607%20175.5%2049.7693%20175.061%2049.7693%20174.519C49.7693%20173.977%2047.1607%20173.537%2043.9428%20173.537C40.7249%20173.537%2038.1162%20173.977%2038.1162%20174.519C38.1162%20175.061%2040.7249%20175.5%2043.9428%20175.5Z'%20class='background-shadows'/%3e%3cpath%20d='M219.421%20168.946C224.226%20168.946%20228.121%20168.289%20228.121%20167.479C228.121%20166.669%20224.226%20166.012%20219.421%20166.012C214.616%20166.012%20210.721%20166.669%20210.721%20167.479C210.721%20168.289%20214.616%20168.946%20219.421%20168.946Z'%20class='background-shadows'/%3e%3cpath%20d='M223.017%20165.083C223.414%20164.76%20223.704%20164.325%20223.848%20163.834C223.954%20163.34%20223.742%20162.745%20223.268%20162.564C222.736%20162.361%20222.167%20162.73%20221.736%20163.101C221.306%20163.472%20220.81%20163.895%20220.246%20163.817C220.536%20163.555%20220.753%20163.222%20220.876%20162.851C220.999%20162.48%20221.023%20162.084%20220.947%20161.701C220.922%20161.542%20220.855%20161.393%20220.752%20161.27C220.456%20160.955%20219.921%20161.089%20219.566%20161.337C218.441%20162.126%20218.128%20163.649%20218.121%20165.02C218.009%20164.527%20218.104%20164.011%20218.102%20163.511C218.099%20163.01%20217.959%20162.432%20217.53%20162.167C217.265%20162.026%20216.966%20161.956%20216.665%20161.964C216.159%20161.945%20215.596%20161.994%20215.25%20162.363C214.817%20162.823%20214.932%20163.59%20215.306%20164.089C215.681%20164.587%20216.247%20164.91%20216.769%20165.258C217.189%20165.506%20217.546%20165.846%20217.816%20166.252C217.848%20166.309%20217.874%20166.369%20217.894%20166.431H221.064C221.773%20166.071%20222.43%20165.618%20223.017%20165.083Z'%20class='background-shadows'/%3e%3cpath%20d='M12.8387%20146.999C12.8387%20146.999%2014.0265%20148.547%2012.2892%20150.881C10.5518%20153.215%209.11951%20155.194%209.69286%20156.652C9.69286%20156.652%2012.313%20152.309%2014.4528%20152.246C16.5926%20152.184%2015.1841%20149.611%2012.8387%20146.999Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M12.8386%20146.999C12.9417%20147.148%2013.0233%20147.312%2013.0809%20147.484C15.1623%20149.921%2016.27%20152.197%2014.2709%20152.253C12.4058%20152.307%2010.16%20155.628%209.63428%20156.467C9.65266%20156.532%209.67432%20156.596%209.69919%20156.659C9.69919%20156.659%2012.3193%20152.315%2014.4591%20152.253C16.5989%20152.19%2015.1839%20149.611%2012.8386%20146.999Z'%20fill='%2314222E'/%3e%3cpath%20d='M15.0477%20148.972C15.0477%20149.518%2014.985%20149.96%2014.9093%20149.96C14.8335%20149.96%2014.7729%20149.529%2014.7729%20148.972C14.7729%20148.416%2014.8487%20148.683%2014.9266%20148.683C15.0045%20148.683%2015.0477%20148.426%2015.0477%20148.972Z'%20fill='%23E5B806'/%3e%3cpath%20d='M15.7966%20149.623C15.3163%20149.884%2014.8987%20150.042%2014.862%20149.975C14.8252%20149.908%2015.1865%20149.645%2015.6668%20149.384C16.1471%20149.123%2015.9567%20149.313%2015.9935%20149.384C16.0303%20149.455%2016.2856%20149.362%2015.7966%20149.623Z'%20fill='%23E5B806'/%3e%3cpath%20d='M6.56021%20146.999C6.56021%20146.999%205.3724%20148.547%207.1076%20150.881C8.84281%20153.215%2010.2773%20155.194%209.70392%20156.652C9.70392%20156.652%207.08164%20152.309%204.94401%20152.246C2.80637%20152.184%204.21271%20149.611%206.56021%20146.999Z'%20class='background-shadows'/%3e%3cpath%20opacity='0.1'%20d='M6.55993%20146.999C6.45583%20147.148%206.37419%20147.311%206.31761%20147.484C4.23623%20149.921%203.1263%20152.197%205.12763%20152.253C6.99049%20152.307%209.23846%20155.628%209.76205%20156.467C9.74441%20156.532%209.72346%20156.596%209.69931%20156.659C9.69931%20156.659%207.07703%20152.315%204.9394%20152.253C2.80176%20152.19%204.21243%20149.611%206.55993%20146.999Z'%20fill='%2314222E'/%3e%3cpath%20d='M4.35107%20148.972C4.35107%20149.518%204.41166%20149.96%204.48738%20149.96C4.56311%20149.96%204.62369%20149.529%204.62369%20148.972C4.62369%20148.416%204.54796%20148.683%204.47224%20148.683C4.39651%20148.683%204.35107%20148.426%204.35107%20148.972Z'%20fill='%23E5B806'/%3e%3cpath%20d='M3.5918%20149.623C4.07212%20149.884%204.49186%20150.042%204.52864%20149.975C4.56542%20149.908%204.2041%20149.645%203.72378%20149.384C3.24346%20149.123%203.4317%20149.313%203.39708%20149.384C3.36246%20149.455%203.11148%20149.362%203.5918%20149.623Z'%20fill='%23E5B806'/%3e%3cpath%20d='M4.72949%20156.456C4.72949%20156.456%208.05278%20156.355%209.05669%20155.643C10.0606%20154.931%2014.1693%20154.084%2014.4181%20155.211C14.6669%20156.339%2019.4117%20160.884%2015.66%20160.914C11.9083%20160.944%206.94285%20160.329%205.94327%20159.723C4.94369%20159.117%204.72949%20156.456%204.72949%20156.456Z'%20fill='%23E8DECA'/%3e%3cpath%20opacity='0.2'%20d='M15.7227%20160.528C11.9711%20160.558%207.0056%20159.943%206.00601%20159.337C5.24443%20158.876%204.94153%20157.217%204.83984%20156.452H4.72949C4.72949%20156.452%204.94585%20159.124%205.93894%20159.73C6.93203%20160.336%2011.904%20160.951%2015.6557%20160.92C16.7375%20160.92%2017.1118%20160.526%2017.0923%20159.959C16.9408%20160.306%2016.5298%20160.521%2015.7227%20160.528Z'%20fill='%2314222E'/%3e%3cpath%20d='M88.558%2089.8622C89.828%2089.7911%2095.806%2089.3425%2099.6031%2087.1836C100.213%2086.8259%20100.902%2086.6237%20101.609%2086.5948C102.816%2086.5603%20104.205%2087.0628%20103.316%2089.8752C101.875%2094.4755%2093.5083%2099.6517%2088.3156%2099.3648C83.3221%2099.0888%2077.3981%2097.083%2073.4864%2090.0305C73.1116%2089.3519%2072.927%2088.5853%2072.9519%2087.8112C72.9974%2086.3877%2073.5166%2084.6041%2076.1973%2086.5926C79.8192%2089.2778%2086.6908%2089.7867%2088.069%2089.8622C88.2319%2089.8709%2088.3951%2089.8709%2088.558%2089.8622Z'%20fill='%23233C52'/%3e%3cpath%20d='M136.59%2089.8622C137.86%2089.7911%20143.838%2089.3425%20147.635%2087.1836C148.245%2086.8259%20148.934%2086.6237%20149.641%2086.5948C150.848%2086.5603%20152.237%2087.0628%20151.348%2089.8752C149.907%2094.4755%20141.541%2099.6517%20136.348%2099.3648C131.354%2099.0888%20125.43%2097.083%20121.519%2090.0305C121.144%2089.3519%20120.959%2088.5853%20120.984%2087.8112C121.03%2086.3877%20121.549%2084.6041%20124.23%2086.5926C127.851%2089.2778%20134.723%2089.7867%20136.101%2089.8622C136.264%2089.8709%20136.427%2089.8709%20136.59%2089.8622Z'%20fill='%23233C52'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_1530_12970'%3e%3crect%20width='238'%20height='175'%20fill='white'%20transform='translate(0%200.5)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e";
var c = /* @__PURE__ */ ((e) => (e.STATE_INVALID = "`state` does not match.", e.COOPERATIVE_NOT_FOUND_ERROR = "ssoNotActivatedForThisCooperative", e.MEMBERSHIP_NOT_FOUND_ERROR = "unknownMembershipNumber", e.NO_PROFILE_FOUND_ERROR = "noUserFoundForThisMembershipNumber", e.TOO_MANY_PROFILES_FOUND_ERROR = "moreThanOneUserForThisMembershipNumber", e.EXTRANET_AUTHENTICATION_FAILED = "notAuthenticatedInPartnerExtranet", e.ACCESS_DENIED = "access_denied", e.INVALID_SCOPE = "invalidScope", e.IS_NOT_AUTHENTICATED = "isNotAuthenticated", e))(c || {});
function z(e) {
  return e.errorCode === c.COOPERATIVE_NOT_FOUND_ERROR ? {
    title: e.i18n._("Votre partenaire ne permet pas de se connecter depuis son Extranet."),
    description: e.i18n._(
      "Vous pouvez contacter {appName} ou votre partenaire pour leur demander d'ajouter cette fonctionnalité. En attendant veuillez vous connecter manuellement.",
      { appName: e.appName }
    )
  } : e.errorCode === c.MEMBERSHIP_NOT_FOUND_ERROR ? {
    title: e.i18n._("Votre partenaire n'a pas transmis votre profil à {appName}", { appName: e.appName }),
    description: e.i18n._(
      "Pour utiliser {appName}, vous devez d'abord demander directement à votre partenaire d'activer le service.",
      { appName: e.appName }
    )
  } : e.errorCode === c.NO_PROFILE_FOUND_ERROR ? {
    title: e.i18n._("Vous y êtes presque !"),
    description: e.i18n._(
      "Il ne reste plus qu’à vous inscrire. Pour bénéficier de la connexion automatique, cliquez sur le lien ci-dessous."
    )
  } : e.errorCode === c.TOO_MANY_PROFILES_FOUND_ERROR ? {
    title: e.i18n._("Impossible de vous connecter automatiquement"),
    description: e.i18n._(
      "Plusieurs comptes {appName} sont associés au même numéro d'adhérent ou de client. Veuillez vous connecter manuellement.",
      { appName: e.appName }
    )
  } : e.errorCode === c.EXTRANET_AUTHENTICATION_FAILED ? {
    title: e.i18n._("Impossible de vous connecter automatiquement"),
    description: e.i18n._("L'extranet de votre partenaire ne vous a pas authentifié.")
  } : e.errorCode === c.INVALID_SCOPE || e.errorCode === c.ACCESS_DENIED ? {
    title: e.i18n._("Interdit"),
    description: e.i18n._("Vous n'êtes pas autorisé à accéder à ce site")
  } : e.errorCode === c.STATE_INVALID ? {
    title: e.i18n._("Authentification impossible"),
    description: e.i18n._("{appName} n'est pas à l'origine de cette requête", { appName: e.appName })
  } : {
    title: e.i18n._("Erreur inattendue..."),
    description: e.i18n._(
      "Une erreur de connexion est survenue. Merci d'essayer à nouveau. Si le problème persiste, n'hésitez pas à contacter le service client"
    )
  };
}
const G = N({
  components: {
    AdnButton: y,
    PFormContainer: U,
    InlineSvg: S
  },
  props: {
    errorDetails: {
      type: Object,
      required: !0
    },
    auth: {
      type: Object,
      default: () => ({
        logout: () => Promise.reject(new Error("No auth service provided"))
      }),
      required: !0
    },
    appName: {
      type: String,
      default: "Aladin"
    },
    i18n: {
      type: Object,
      default: null
    },
    captureMessage: {
      type: Function,
      default: () => {
      }
    }
  },
  setup(e) {
    const { auth: t, errorDetails: n, i18n: o } = e, { title: s, description: C } = z({
      appName: e.appName,
      i18n: o,
      errorCode: n.errorCode,
      errorDescription: n.errorDescription
    });
    return e.captureMessage(`Auth0 error: ${n.errorDescription}`), {
      title: s,
      description: C,
      logout: t.logout,
      undrawFeelingSvg: j
    };
  }
}), W = { class: "oauth-error-callback" }, X = { class: "svg_wrapper" }, Y = { class: "oauth-callback__title" }, J = { class: "oauth-callback__body" };
function Q(e, t, n, o, s, C) {
  const r = u("inline-svg"), k = u("adn-button"), $ = u("p-form-container");
  return i(), a("div", W, [
    v($, null, {
      title: _(() => t[1] || (t[1] = [])),
      body: _(() => [
        d("div", X, [
          e.undrawFeelingSvg ? (i(), b(r, {
            key: 0,
            src: e.undrawFeelingSvg,
            style: { "text-align": "center" },
            "aria-label": "aladin"
          }, null, 8, ["src"])) : l("", !0)
        ]),
        d("h1", Y, h(e.title), 1),
        d("p", J, h(e.description), 1),
        v(k, {
          class: "adn-button--fullwidth oauth-callback__btn",
          "icon-position": "right",
          kind: "primary",
          markup: "a",
          onClick: t[0] || (t[0] = (l2) => e.logout())
        }, {
          default: _(() => [
            E(h(e.i18n._("Se connecter avec les identifiants")) + " " + h(e.appName), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const C2 = /* @__PURE__ */ f(G, [["render", Q]]), K = N({
  name: "AdnAnimatedLoading",
  components: { AdnButton: y, InlineSvg: S },
  props: {
    withBackButton: {
      type: Boolean,
      default: !1
    },
    imageWidth: {
      type: String,
      default: "40rem"
    }
  },
  computed: {
    cssProps() {
      return {
        "--adnAnimatedLoadingImageWidth": this.imageWidth
      };
    }
  },
  methods: {
    back() {
      return this.$router && this.$router.back();
    }
  }
}), x = { class: "adn-animated-loading__container" }, e2 = {
  key: 0,
  class: "adn-animated-loading_content-container",
  "data-test-slot-container": ""
};
function t2(e, t, n, o, s, C) {
  const r = u("inline-svg"), k = u("adn-button");
  return i(), a("div", {
    class: "adn-animated-loading",
    style: M(e.cssProps)
  }, [
    d("div", x, [
      v(r, {
        class: "adn-animated-loading__image",
        src: "/themes/current/images/loading.svg"
      }),
      e.$slots.default ? (i(), a("div", e2, [
        m(e.$slots, "default")
      ])) : l("", !0),
      e.withBackButton ? (i(), b(k, {
        key: 1,
        kind: "link",
        "icon-name": "navigation-direction-left",
        "icon-position": "left",
        "data-test-back-button": "",
        onClick: e.back
      }, {
        default: _(() => t[0] || (t[0] = [
          E(" Retour ")
        ])),
        _: 1
      }, 8, ["onClick"])) : l("", !0)
    ])
  ], 4);
}
const n2 = /* @__PURE__ */ f(K, [["render", t2]]), o2 = /Redirected when going from (.+) to (.+) via a navigation guard/, i2 = N({
  components: { AdnAnimatedLoading: n2 },
  props: {
    targetRoute: String,
    router: {
      type: Object,
      default: () => ({
        push: () => {
        }
      }),
      required: !0
    },
    auth: {
      type: Object,
      default: () => ({
        onUserLogged: () => Promise.reject(new Error("No auth service provided"))
      }),
      required: !0
    },
    i18n: {
      type: Object,
      default: null
    }
  },
  setup(e) {
    const { router: t, auth: n } = e;
    R(async () => {
      try {
        await n.onUserLogged(), await t.push(e.targetRoute).catch((o) => {
          if (!o2.exec(o.message ?? ""))
            throw o;
        });
      } catch (o) {
        await t.push({
          name: "auth-callback-error",
          params: { error_code: o.message }
        });
      }
    });
  }
}), a2 = { class: "container oauth-callback" }, s2 = { class: "oauth-callback__main-content" }, r2 = { class: "oauth-callback__title" }, d2 = { class: "card-body oauth-callback__body" };
function c2(e, t, n, o, s, C) {
  const r = u("adn-animated-loading");
  return i(), a("div", a2, [
    d("div", s2, [
      d("div", null, [
        v(r, {
          class: "img-fluid",
          alt: "loading"
        }),
        d("h1", r2, h(e.i18n._("Redirection en cours")), 1),
        d("div", d2, h(e.i18n._(
          "Nous sommes sur le point de vous rediriger vers une autre page, veuillez patienter quelques instants."
        )), 1)
      ])
    ])
  ]);
}
const p2 = /* @__PURE__ */ f(i2, [["render", c2]]);
export {
  p2 as VAuthCallback,
  C2 as VAuthCallbackError
};
